<div class="vc-sales vc-view-shell">
  <main class="vc-sales__layout vc-view-content">
    <section class="vc-sales__frame vc-surface-panel">
      <!-- ==================== DESKTOP HEADER ==================== -->
      <header class="vc-sales__header vc-sales__header--desktop">
        <!-- Filters toolbar -->
        <div class="vc-sales__toolbar">
          <div class="vc-sales__filters-row">
            <!-- Search -->
            <div class="vc-sales__filter-group vc-sales__filter-group--search">
              <span class="p-input-icon-left">
                <i class="fas fa-search"></i>
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="searchText"
                  (ngModelChange)="onSearchChange()"
                  [placeholder]="'COMMON.SEARCH' | translate"
                  class="vc-sales__search-input"
                />
              </span>
            </div>

            <!-- Date Range -->
            <div class="vc-sales__filter-group">
              <p-datepicker
                [(ngModel)]="dateRange"
                selectionMode="range"
                [showIcon]="true"
                [showButtonBar]="true"
                dateFormat="dd/mm/yy"
                [placeholder]="'SALES.FILTERS.DATE_RANGE' | translate"
                (onSelect)="onDateRangeChange()"
                (onClearClick)="onDateRangeChange()"
                [style]="{ width: '100%' }"
              ></p-datepicker>
            </div>

            <!-- Quick Date Filters -->
            <div class="vc-sales__quick-filters">
              <button
                class="vc-sales__quick-btn"
                (click)="setDateFilter('today')"
                [class.vc-sales__quick-btn--active]="activeQuickFilter === 'today'"
              >
                {{ "COMMON.PERIODS.TODAY" | translate }}
              </button>
              <button
                class="vc-sales__quick-btn"
                (click)="setDateFilter('week')"
                [class.vc-sales__quick-btn--active]="activeQuickFilter === 'week'"
              >
                {{ "COMMON.PERIODS.THIS_WEEK" | translate }}
              </button>
              <button
                class="vc-sales__quick-btn"
                (click)="setDateFilter('month')"
                [class.vc-sales__quick-btn--active]="activeQuickFilter === 'month'"
              >
                {{ "COMMON.PERIODS.THIS_MONTH" | translate }}
              </button>
              <button
                class="vc-sales__quick-btn"
                (click)="setDateFilter('all')"
                [class.vc-sales__quick-btn--active]="activeQuickFilter === 'all'"
              >
                {{ "COMMON.ALL" | translate }}
              </button>
            </div>

            <!-- Clear Filters -->
            <button
              class="vc-sales__clear-btn"
              (click)="clearFilters()"
              *ngIf="hasActiveFilters"
              pTooltip="{{ 'COMMON.CLEAR_FILTERS' | translate }}"
            >
              <i class="fas fa-times"></i>
            </button>

            <!-- Add button -->
            <button
              pButton
              class="p-button-primary p-button-sm"
              (click)="openCreateSale()"
              *ngIf="canCreateSales"
            >
              <i class="fas fa-plus"></i>
              <span>{{ "SALES.TITLE.ADD" | translate }}</span>
            </button>
          </div>
        </div>

        <!-- Navigation Tabs -->
        <nav class="vc-sales__nav">
          <div class="vc-sales__tabs">
            <a
              class="vc-sales__tab"
              [routerLink]="['.']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="vc-sales__tab--active"
            >
              <i class="fas fa-list"></i>
              <span>{{ "SALES.TABS.LIST" | translate }}</span>
            </a>
            <a
              class="vc-sales__tab"
              [routerLink]="['stats']"
              routerLinkActive="vc-sales__tab--active"
            >
              <i class="fas fa-chart-pie"></i>
              <span>{{ "SALES.TABS.STATS" | translate }}</span>
            </a>
          </div>
        </nav>
      </header>

      <!-- ==================== MOBILE HEADER ==================== -->
      <header class="vc-sales__header vc-sales__header--mobile">
        <!-- Tabs + Search inline -->
        <div class="vc-sales__mobile-top">
          <nav class="vc-sales__mobile-tabs">
            <a
              class="vc-sales__mobile-tab"
              [routerLink]="['.']"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="vc-sales__mobile-tab--active"
            >
              <i class="fas fa-list"></i>
            </a>
            <a
              class="vc-sales__mobile-tab"
              [routerLink]="['stats']"
              routerLinkActive="vc-sales__mobile-tab--active"
            >
              <i class="fas fa-chart-pie"></i>
            </a>
          </nav>
        </div>

        <!-- Compact filters: Search + Filter toggle -->
        <div class="vc-sales__mobile-filters">
          <div class="vc-sales__mobile-search">
            <i class="fas fa-search"></i>
            <input
              pInputText
              type="text"
              [(ngModel)]="searchText"
              (ngModelChange)="onSearchChange()"
              [placeholder]="'COMMON.SEARCH' | translate"
            />
          </div>
          <button
            class="vc-sales__mobile-filter-btn"
            (click)="toggleMobileFilters()"
            [class.vc-sales__mobile-filter-btn--active]="
              showMobileFilters || hasActiveFilters
            "
          >
            <i class="fas fa-sliders-h"></i>
            <span
              class="vc-sales__filter-indicator"
              *ngIf="hasActiveFilters"
            ></span>
          </button>
        </div>

        <!-- Collapsible quick filters -->
        <div class="vc-sales__mobile-quick-filters" *ngIf="showMobileFilters">
          <div class="vc-sales__mobile-pills">
            <button
              class="vc-sales__pill"
              (click)="setDateFilter('today')"
              [class.vc-sales__pill--active]="activeQuickFilter === 'today'"
            >
              {{ "COMMON.PERIODS.TODAY" | translate }}
            </button>
            <button
              class="vc-sales__pill"
              (click)="setDateFilter('week')"
              [class.vc-sales__pill--active]="activeQuickFilter === 'week'"
            >
              {{ "COMMON.PERIODS.THIS_WEEK" | translate }}
            </button>
            <button
              class="vc-sales__pill"
              (click)="setDateFilter('month')"
              [class.vc-sales__pill--active]="activeQuickFilter === 'month'"
            >
              {{ "COMMON.PERIODS.THIS_MONTH" | translate }}
            </button>
            <button
              class="vc-sales__pill"
              (click)="setDateFilter('all')"
              [class.vc-sales__pill--active]="activeQuickFilter === 'all'"
            >
              {{ "COMMON.ALL" | translate }}
            </button>
          </div>
          <button
            class="vc-sales__mobile-clear"
            (click)="clearFilters()"
            *ngIf="hasActiveFilters"
          >
            <i class="fas fa-times"></i>
            {{ "COMMON.CLEAR_FILTERS" | translate }}
          </button>
        </div>
      </header>

      <!-- Content area -->
      <div class="vc-sales__content">
        <router-outlet></router-outlet>
      </div>
    </section>
  </main>

  <!-- ==================== FAB (Floating Action Button) - Mobile only ==================== -->
  <button
    class="vc-sales__fab"
    (click)="openCreateSale()"
    *ngIf="canCreateSales"
    [attr.aria-label]="'SALES.TITLE.ADD' | translate"
  >
    <i class="fas fa-plus"></i>
  </button>
</div>
